import React, { useState, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import "./formTitle.css";
import "./themeCheckbox.css";
import "./themePlaceholder.css";
import FormHeader from "../common/FormHeader";

function MEWPChecklist() {
  const sigCanvasRef = useRef(null);
  const [form, setForm] = useState({
    siteAddress: "",
    serialNo: "",
    checks: Array(17).fill(false),
    notes: "",
    equipmentStatus: "Fit for use",
    operatorName: "",
    signature: ""
  });

  const checkLabels = [
    "Hydraulic oil level in tank",
    "Machine warning lights / audible safety devices",
    "For damage particularly to the arm and work platform",
    "For cracks or deformation particularly to the arm and work platform",
    "Harness anchor points for security",
    "Cylinders, hoses, pipes and valves for damage or hydraulic leaks",
    "Platform for security of all fastenings",
    "Correct function of holding valves",
    "For missing or illegible operational markings",
    "Operation, security, and condition of stabiliser legs",
    "Function of all platform and pedestal controls at low level to confirm correct function and controls are free and return to the neutral position",
    "Operation of emergency lowering controls and valves",
    "Interlocks for correct function",
    "Operation of emergency stop buttons",
    "Manufactures Instruction Manual is available with vehicle and referred to for any additional checks that are required for the particular vehicle",
    "Insulated aerial device (IAD); arms, bucket, and liners for damage to the insulating components",
    "Statutory 6 month, Lifting Operations & Lifting Equipment Regulations 1998 (LOLER) Inspection certificate is available and in date"
  ];

  const handleInput = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCheck = (idx) => {
    const updated = [...form.checks];
    updated[idx] = !updated[idx];
    setForm({ ...form, checks: updated });
  };

  const clearSignature = () => {
    sigCanvasRef.current.clear();
    setForm(prev => ({
      ...prev,
      signature: ""
    }));
  };

  const saveSignature = () => {
    if (!sigCanvasRef.current.isEmpty()) {
      setForm(prev => ({
        ...prev,
        signature: sigCanvasRef.current.getTrimmedCanvas().toDataURL("image/png")
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("MEWP Checklist submitted!");
  };

  return (
    <div style={{height: '100vh', overflowY: 'auto', background: 'linear-gradient(135deg, #f7fafd 0%, #eaf0fe 100%)'}}>
      <FormHeader />
      <div className="container py-4">
      
        <form onSubmit={handleSubmit} className="bg-white p-4 rounded-4 shadow-lg">
          <h2
            className="text-center text-white py-2 mb-4 rounded"
            style={{
              backgroundColor: "#8b1634",
              letterSpacing: "1px",
              fontSize: "1.7rem"
            }}
          >
            MEWP Checklist
          </h2>
          <div className="row mb-4">
            <div className="col-12 col-md-6 mb-3 mb-md-0">
              <label className="form-label fw-semibold" style={{color:'#8b1634'}}>Site Address</label>
              <input type="text" name="siteAddress" value={form.siteAddress} onChange={handleInput} placeholder="Site Address" className="form-control custom-input" />
            </div>
            <div className="col-12 col-md-6">
              <label className="form-label fw-semibold" style={{color:'#8b1634'}}>MEWP Serial / Reg No.</label>
              <input type="text" name="serialNo" value={form.serialNo} onChange={handleInput} placeholder="MEWP Serial / Reg No." className="form-control custom-input" />
            </div>
          </div>

          {/* Checklist Section */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="p-3 border border-2 rounded-4 bg-light-subtle">
                <div className="fw-bold mb-3" style={{color:'#8b1634', fontSize:'1.1rem'}}>Check Confirm (tick)</div>
                {checkLabels.map((label, idx) => (
                  <div key={idx} className="d-flex align-items-center justify-content-between border-bottom py-2 fw-medium">
                    <span style={{color:'#222'}}>{label}</span>
                    <input type="checkbox" checked={form.checks[idx] || false} onChange={()=>handleCheck(idx)} className="form-check-input theme-checkbox" />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Notes/Comments */}
          <div className="row mb-4">
            <div className="col-12">
              <label className="form-label fw-semibold" style={{color:'#8b1634'}}>Notes / Comments</label>
              <textarea name="notes" value={form.notes} onChange={handleInput} placeholder="Notes / Comments" className="form-control custom-input" style={{minHeight:80}} />
            </div>
          </div>

          {/* Equipment Status & Operator Name/Signature */}
          <div className="row mb-4">
            <div className="col-12 col-md-6 mb-3 mb-md-0">
              <div className="fw-bold mb-2" style={{color:'#8b1634'}}>I confirm the above checks have been made and the equipment is:</div>
              <div className="d-flex gap-4 mb-3">
                <label style={{fontWeight:500, color:'#8b1634'}}>
                  <input type="radio" name="equipmentStatus" value="Fit for use" checked={form.equipmentStatus==='Fit for use'} onChange={handleInput} className="form-check-input me-2" style={{accentColor:'#8b1634'}} /> Fit for use
                </label>
                <label style={{fontWeight:500, color:'#8b1634'}}>
                  <input type="radio" name="equipmentStatus" value="Defective" checked={form.equipmentStatus==='Defective'} onChange={handleInput} className="form-check-input me-2" style={{accentColor:'#8b1634'}} /> Defective
                </label>
              </div>
              <input type="text" name="operatorName" value={form.operatorName} onChange={handleInput} placeholder="Operator Name" className="form-control custom-input" />
            </div>
            <div className="col-12 col-md-4">
              <div className="fw-bold mb-2" style={{color:'#8b1634'}}>Operator Signature</div>
              <div style={{
                width: '100%',
                border: '2px solid #8b1634',
                borderRadius: '18px',
                background: '#e9cfd6',
                padding: '0.5rem',
                textAlign: 'left',
                position: 'relative',
                minHeight: '120px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}>
                <SignatureCanvas
                  ref={sigCanvasRef}
                  penColor="#8b1634"
                  backgroundColor="#e9cfd6"
                  clearOnResize={false}
                  velocityFilterWeight={0.7}
                  minWidth={1}
                  maxWidth={2.5}
                  dotSize={1.5}
                  throttle={16}
                  canvasProps={{
                    width: window.innerWidth > 600 ? 350 : 300,
                    height: 100,
                    style: {
                      width: '100%',
                      height: '100px',
                      border: 'none',
                      borderRadius: '18px',
                      background: '#e9cfd6',
                      display: 'block',
                      touchAction: 'none'
                    }
                  }}
                  onEnd={saveSignature}
                />
                <div style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: '4px'
                }}>
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm rounded-pill px-3"
                    style={{
                      background: 'transparent',
                      color: '#8b1634',
                      borderColor: '#8b1634'
                    }}
                    onClick={clearSignature}>
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="row">
  <div className="col-12 d-flex justify-content-center">
    <button
      type="submit"
      className="btn btn-lg text-white fw-bold px-5 py-2 mt-4"
      style={{
        backgroundColor: "#8b1634",
        borderRadius: "30px",
        boxShadow: "0 4px 12px rgba(139,22,52,0.3)"
      }}
    >
      Submit
    </button>
  </div>
</div>
        </form>
      </div>
    </div>
  );
}

export default MEWPChecklist;
